import { useEffect } from 'react';
import { AccountManagerQueries } from '@frontend/api-account-manager';
import { AccountManagerProfile, AccountManagerPopupController } from '@frontend/account-manager-profile';

export const AccountManagerSection = ({
  handleOpenProfilePanel,
  hideSection,
}: {
  handleOpenProfilePanel: () => void;
  hideSection: () => void;
}) => {
  const { data: accountManagerData } = AccountManagerQueries.useAccountManagerDataQuery();
  useEffect(() => {
    if (!accountManagerData) hideSection();
  }, [accountManagerData, hideSection]);
  return (
    accountManagerData && (
      <>
        <AccountManagerProfile accountManagerData={accountManagerData} />
        <AccountManagerPopupController onShowPopup={handleOpenProfilePanel} />
      </>
    )
  );
};
